import type { FC } from "react";
import type { MatchInfoEntry as XpaMatchInfoEntry } from "@motain/xpa-proto-files-web/lib/types/match_info";
import { EntityLogo } from "@/components/entity-logo/EntityLogo";
import { isNonNullable } from "@/types/isNonNullable";
import styles from "./MatchInfoEntry.module.scss";
import classnames from "classnames";

export const MatchInfoEntry: FC<XpaMatchInfoEntry> = (props) => {
  const { title, subtitle, icon } = props;

  return (
    <>
      {isNonNullable(icon) && (
        <EntityLogo
          alt={icon.alt}
          src={icon.path}
          darkModeSrc={icon.darkModePath}
          className={styles.logo}
        />
      )}
      <span className={classnames("title-7-medium", styles.title)}>
        {title}
      </span>

      <span className={classnames("title-8-regular", styles.subtitle)}>
        {subtitle}
      </span>
    </>
  );
};
